<div class="relative">
  <label
    *ngIf="label"
    class="block text-xxs font-medium text-gray-500 absolute pointer-events-none left-4 top-1">
    {{ label }}
  </label>

  <select
         [formControl]="control"
         class="appearance-none w-full !outline-none placeholder-gray-400 !focus:outline-none rounded-lg text-sm align-bottom bg-white pl-4 pr-12 pt-5 pb-1 border border-gray-200 transition-colors focus:border-primary-two">
    <ng-container *ngFor="let option of options">
      <option [value]="option.value">{{ (option.labelKey | translate) ?? option.label }}</option>
    </ng-container>
  </select>

  <div class="absolute top-0 right-0 bottom-0 flex items-center justify-center pr-4 pointer-events-none">
    <img ngSrc="/assets/images/icon-arrow-down.svg" [width]="11" [height]="4">
  </div>
</div>
